import { render, staticRenderFns } from "./3. showDisabledDays.vue?vue&type=template&id=05587006&"
import script from "./3. showDisabledDays.vue?vue&type=script&lang=js&"
export * from "./3. showDisabledDays.vue?vue&type=script&lang=js&"
import style0 from "../dist/vue-coe-calendar.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/viniazvd/vue-coe-calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05587006')) {
      api.createRecord('05587006', component.options)
    } else {
      api.reload('05587006', component.options)
    }
    module.hot.accept("./3. showDisabledDays.vue?vue&type=template&id=05587006&", function () {
      api.rerender('05587006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "examples/3. showDisabledDays.vue"
export default component.exports